import { EcomAccessory } from './accessory';
import { EcomAccessoryPackage } from './accessory-package';
import { EcomBaseProduct } from './base-product';
import { EcomProductCombination } from './product-combination';
import { EcomProductPlan } from './product-plan';

export interface EcomProduct extends EcomBaseProduct {
  modelYear: string;
  trimCode: string;
  trimDescription?: string;
  driveType?: string;
  variantCode: string;
  modelCode: string;
  modelDescription?: string;
  variantSku: string;
  bodyType?: string;
  fuel?: string;
  transmission?: string;
  productImage?: string;
  previewImage?: string;
  productUrl?: string;
  brochure?: string;
  specifications?: EcomSpecification[];
  combinations?: EcomProductCombination[];
  accessories?: EcomAccessory[];
  accessoryPackages?: EcomAccessoryPackage[];
  insurancesList?: EcomProductPlan[];
  servicesList?: EcomProductPlan[];
  tplPrice?: EcomProductPlan[];
  registrationPrice?: EcomProductPlan[];
  extendedWarrenty?: EcomProductPlan[];
  customerCarePackages?: EcomProductPlan[];
}

export interface EcomSpecification {
  attrName: string;
  attrValue?: string;
}

export enum EcomProductCustomOptionType {
  Exterior = 'Exterior',
  Interior = 'Interior',
}

export interface EcomProductCustomOption {
  customOptionName: EcomProductCustomOptionType;
  colorCode: string;
  colorDescrption?: string;
  isDefault?: boolean;
  variantThumbImage?: string;
}

export interface EcomCustomer {
  firstName: string;
  lastName: string;
  crmCustomerID: string;
  email?: string;
  phoneNumber: string;
  gender?: string;
}
